// toast.js
import { toasts } from 'svelte-toasts';

//
// success
// error
// info
// warning
//


export const showToast = (tTitle, tDesc = '', tType = 'info', tDuration = 5000) => {
	const toast = toasts.add({
		title: tTitle,
		description: tDesc,
		duration: tDuration, // 0 or negative to avoid auto-remove
		placement: 'bottom-right',
		type: tType,
		theme: 'light',
		showProgress: true,
		onClick: () => {
			toasts.add({
				title: 'Clicked: ' + tTitle,
				description: tDesc,
				type: tType,
				placement: 'center-center',
				theme: 'light',
				duration: 0,
			});
		},
	});
};